import iyfaaoPrice from "./pricelist";

const iyfaoGroupCat = {
    "Painting" :{
        "Any desired topic of your choice" : {
            1:{
                "id":1,"number":"P01", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["P01"]
                },
                2:{
                "id":2,"number":"P02", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["P02"]
                },
                3:{
                "id":3,"number":"P03", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["P03"]
                },
                4:{
                "id":4,"number":"P04", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["P04"]
                },
                5:{
                "id":5,"number":"P05", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["P05"]
                },
                6:{
                "id":6,"number":"P06", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["P06"]
                },
        },  
    },

    "Theme" :{
        "Movie Hero in Action (Your favourite movie character)" : {
            1:{
                "id":1,"number":"T01", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["T01"]
                },
                2:{
                "id":2,"number":"T02", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["T02"]
                },
                3:{
                "id":3,"number":"T03", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["T03"]
                },
                4:{
                "id":4,"number":"T04", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["T04"]
                },
                5:{
                "id":5,"number":"T05", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["T05"]
                },
                6:{
                "id":6,"number":"T06", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["T06"]
                },
        },  
    },

    "Colouring" :{
        "Preschool Group" : {
            1:{
                "id":1,"number":"C-1", "name":"Debut", "des":"Age 4 or below",  "price":47
                },
                2:{
                "id":2,"number":"C-2", "name":"Junior	", "des":"Age 4 to 5", "price":47
                },
                3:{
                "id":3,"number":"C-3", "name":"Emerging", "des":"Age 5 to 8","price":47
                },
            
        },
       
    },

    "Sculpturing" :{
        "Ceremics" : {
            1:{
                "id":1,"number":"SC-1", "name":"Debut", "des":"Age 7 or below",  "price":55
                },
                2:{
                "id":2,"number":"SC-2", "name":"Junior	", "des":"Age 7 to 9", "price":55
                },
                3:{
                "id":3,"number":"SC-3", "name":"Emerging", "des":"Age 9 to 12","price":55
                },
                4:{
                "id":4,"number":"SC-4", "name":"Youth","des":"Age 12 to 15", "price":65
                },
                5:{
                "id":5,"number":"SC-5", "name":"Young Artist","des":"Age 15 to 18", "price":65
                },
                6:{
                "id":6,"number":"SC-6", "name":"Artist","des":"Age 18 or above", "price":75
                },
        }, 
        "Handcraft" : {			
            1:{
                "id":1,"number":"SH-1", "name":"Debut", "des":"Age 7 or below",  "price":55
                },
                2:{
                "id":2,"number":"SH-2", "name":"Junior	", "des":"Age 7 to 9", "price":55
                },
                3:{
                "id":3,"number":"SH-3", "name":"Emerging", "des":"Age 9 to 12","price":55
                },
                4:{
                "id":4,"number":"SH-4", "name":"Youth","des":"Age 12 to 15", "price":65
                },
                5:{
                "id":5,"number":"SH-5", "name":"Young Artist","des":"Age 15 to 18", "price":65
                },
                6:{
                "id":6,"number":"SH-6", "name":"Artist","des":"Age 18 or above", "price":75
                },
        
        },
      
    },

    "Digital":{
        "Any desired topic of your choice, created on a digital medium." : {
            1:{
                "id":1,"number":"D01", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["D01"]
                },
                2:{
                "id":2,"number":"D02", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["D02"]
                },
                3:{
                "id":3,"number":"D03", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["D03"]
                },
                4:{
                "id":4,"number":"D04", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["D04"]
                },
                5:{
                "id":5,"number":"D05", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["D05"]
                },
                6:{
                "id":6,"number":"D06", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["D06"]
                },
        },  
    }

}

export default iyfaoGroupCat;